@let org = selectActiveOrganization$ | async;
<div class="menu-level1 flex-col space-between-center h-100">
  <div class="flex-col">
    <span
      class="lumix-logo ui-icon-lumana-logo flex-col center-center"
      aria-label="Lumix logo"
    ></span>
    <hr class="hr" />
    @for (item of navigationItems(); track item.segment) {
      <div
        class="menu-item"
        [matTooltip]="item.labelKey | translate"
        matTooltipClass="sidebar-tooltip sidebar-navigation-tooltip"
        matTooltipPosition="right"
      >
        <a
          class="flex-row center-center"
          [routerLink]="item.path"
          routerLinkActive="active"
        >
          <span [class]="item.icon" class="icon"></span>
        </a>
      </div>
    }
  </div>
  <div class="bottom-menu flex-col start-start w-100">
    <div
      class="user-icon-wrapper flex-row center-center"
      [matTooltip]="'SIDEBAR.USER' | translate"
      matTooltipClass="sidebar-tooltip sidebar-navigation-tooltip"
      matTooltipPosition="right"
    >
      <app-ui-dropdown #userMenuDropdown [height]="userMenuHeight">
        <div class="flex-row center-center w-100" input>
          <span class="user-icon icon ui-icon-user"></span>
        </div>

        <ng-template #contentTemplate>
          <div #userMenu class="user-menu">
            <div class="user-menu-inner flex-col">
              <ng-container *ngIf="selectUser$ | async as user">
                <div class="menu-title">
                  {{ user.firstname }} {{ user.lastname }}
                </div>
                <div class="menu-title">
                  {{ user.email }}
                </div>
              </ng-container>
              <hr class="hr" />
              @for (item of userItems; track item.segment) {
                <a
                  [routerLink]="item.path"
                  class="menu-item flex-row space-between-center"
                >
                  <div class="flex-row start-center gap-8">
                    <span class="icon" [class]="item.icon"></span>
                    <span>{{ item.labelKey | translate }}</span>
                  </div>
                </a>
              }
              <div
                (click)="logout(); userMenuDropdown.toggleDropdown()"
                class="menu-item logout-button flex-row space-between-center"
              >
                <div class="flex-row start-center gap-8">
                  <span class="icon ui-icon-logout"></span>
                  <span>{{ 'USER_MENU.LOGOUT' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </app-ui-dropdown>
    </div>
    <hr class="hr" />
    <div
      class="org-icon-wrapper flex-row center-center"
      [matTooltip]="'SIDEBAR.SWITCH_ORGANIZATION' | translate"
      matTooltipClass="sidebar-tooltip sidebar-navigation-tooltip"
      matTooltipPosition="right"
      (click)="toggleSwitchOrgMenu()"
    >
      @if (org) {
        <ui-avatar
          class="org-avatar"
          [name]="org.settings.orgName"
          [color]="org.settings.orgColor"
        ></ui-avatar>
      }
    </div>
  </div>
</div>

@if (isOrgSelectorOpen()) {
  <app-switch-organization
    [activeOrganization]="selectActiveOrganization$ | async"
    [userOrganizations]="userOrganizations()"
    (onMenuClosed)="closeSwitchOrgMenu()"
  ></app-switch-organization>
}
